import React from 'react';
import './styles/main.css';
import Routes from './Utilities/Routes';
import Layout from './Utilities/Layout';

function App() {
  return (
    <Layout>
      <Routes />
    </Layout>
  );
}

export default App;
